<template>
  <v-content>

    <v-container class="background-img" fill-height fluid>
      <v-row justify="center">
        <v-col cols="12" lg="7" md="6" sm="7" xs="7">
          <v-form ref="registerForm">
            <v-card>
              <v-card-title class="justify-center">
                <v-icon class="px-1" color="white" large>mdi-account-plus</v-icon>
                <label :class="['whiteColor', 'px-1',($vuetify.breakpoint.mdAndUp?'':'small-font')]">{{
                    universityTitle
                  }}</label>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <div class="d-flex justify-center">
                  <img :src="universityLogo" alt="" class="logo-img" style="width: 400px;"/>
                </div>
                <v-text-field
                    ref="arName"
                    v-model="data.arName"
                    :error-messages="errorMessages"
                    :label="this.$t('AR_NAME')"
                    :rules="arNameRules"
                    counter="100"
                    maxlength="100"
                    required
                    @keydown.space="preventLeadingSpace"
                ></v-text-field>
                <v-text-field
                    v-model="data.enName"
                    :label="this.$t('EN_NAME')"
                    :rules="enNameRules"
                    counter="100"
                    maxlength="100"
                    required
                    @keydown.space="preventLeadingSpace"
                ></v-text-field>
                <v-text-field
                    v-model="data.email"
                    :label="this.$t('EMAIL')"
                    :rules="emailRules"
                    required
                    @keydown.space="preventLeadingSpace"
                ></v-text-field>
                <v-text-field
                    v-model="data.username"
                    :label="this.$t('USERNAME')"
                    :rules="usernameRules"
                    counter="10"
                    maxlength="10"
                    required
                    @keydown.space="preventLeadingSpace"
                ></v-text-field>
                <v-text-field
                    v-model="data.password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :label="this.$t('PASSWORD')"
                    :rules="passwordRulse"
                    :type="showPassword ? 'text' : 'password'"
                    counter="20"
                    maxlength="20"
                    name="input-10-2"
                    @change="passwordChanged"
                    @keyup="passwordChanged"
                    @click:append="showPassword = !showPassword"
                    @keydown.space="preventLeadingSpace"
                ></v-text-field>
                <v-text-field
                    ref="confirmPassword"
                    v-model="data.confirmPassword"
                    :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :disabled="allowDisabled"
                    :label="this.$t('CONFIRM_PASSWORD')"
                    :rules="confirmPasswordRulse"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    counter="20"
                    maxlength="20"
                    name="input-10-2"
                    @click:append="showConfirmPassword = !showConfirmPassword"
                    @keydown.space="preventLeadingSpace"
                ></v-text-field>

                 <v-radio-group v-model="data.religion" height="10" row>
                  <v-radio
                      :label="this.$t('ADMISSION_DATA.STEP1.MUSLIM')"
                      :value="84"
                      color="primary"
                  ></v-radio>
                  <v-radio
                      :label="this.$t('ADMISSION_DATA.STEP1.CHRISTIAN')"
                      :value="85"
                      color="primary"
                  ></v-radio>
                </v-radio-group>

                <v-autocomplete
                    ref="nationality"
                    v-model="data.nationality"
                    :items="serverTranslateArray(nationalities, 'name')"
                    :placeholder="this.$t('UserData.NATIONALITY')"
                    :rules="nationalityRules"
                    append-icon="mdi-earth"
                    item-text="name"
                    item-value="id"
                    name="nationality"
                    @change="changeNationality()"
                ></v-autocomplete>
                <v-radio-group v-model="radios" height="10" row @change="reset">
                  <v-radio
                      :disabled="data.nationality !== 1 && data.nationality !== ''"
                      :label="this.$t('NID')"
                      :value="1"
                      color="primary"
                  ></v-radio>
                  <v-radio
                      :disabled="data.nationality === 1"
                      :label="this.$t('PASSPORT')"
                      :value="2"
                      color="primary"
                  ></v-radio>
                </v-radio-group>
                <v-text-field
                    ref="cardID"
                    v-model="data.cardID"
                    :counter="radios === 1 ? 14 : 25"
                    :label="radios === 1 ? $t('NID') : $t('PASSPORT')"
                    :maxlength="radios === 1 ? 14 : 25"
                    :rules="radios === 1 ? NIDRulse : passportRulse"
                    required
                    @keyup="radios === 1 ? setGenderDob() : '' "
                    @mouseenter="radios === 1 ? setGenderDob() : '' "
                    @keydown.space="preventLeadingSpace"
                ></v-text-field>
                <v-radio-group v-model="data.gender" height="10" row>
                  <v-radio
                      :disabled="radios === 1"
                      :label="this.$t('UserData.MALE')"
                      :value="13"
                      color="primary"
                  ></v-radio>
                  <v-radio
                      :disabled="radios === 1"
                      :label="this.$t('UserData.FEMALE')"
                      :value="14"
                      color="primary"
                  ></v-radio>
                </v-radio-group>

                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :disabled="radios === 1"
                    :nudge-right="40"
                    min-width="290px"
                    offset-y
                    row
                    transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        ref="dOB"
                        v-model="data.dOB"
                        :class="{'error--text':dOBRules}"
                        :disabled="radios === 1"
                        :label="$t('UserData.BIRTHDAY')"
                        :rules="dOBRules"
                        append-icon="mdi-calendar"
                        outlined
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="data.dOB"
                      :disabled="radios === 1"
                      :max="maxDate.toISOString()"
                      :min="minDate.toISOString()"
                      :value="((new Date).setFullYear(new Date().getFullYear() - 14))"
                      no-title
                      @input="menu = false"
                  />
                </v-menu>

                <!--prequal data-->

                <v-row>
                  <v-col cols="4" lg="4">
                    <v-autocomplete
                        v-model="data.certificateType"
                        :disabled="isDobInvalid"
                        :items="data.certificateTypes"
                        :label="$t('ADMISSION_DATA.STEP2.CERTIFICATION')"
                        :rules="requiredRules"
                        item-text="name"
                        item-value="id"
                        outlined
                    >
                      <template v-slot:selection="data">
                        <v-chip v-bind="data.attrs">
                          {{ serverTranslate(data.item.name) }}
                        </v-chip>
                      </template>
                      <template v-slot:item="data">
                        <template v-if="typeof data.item === 'object'">
                          <v-list-item-content>
                            <v-list-item-title
                                v-html="serverTranslate(data.item.name)"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="4" lg="4">

                    <v-autocomplete
                        v-model="data.preQualYear"
                        :disabled="isDobInvalid"
                        :items="filteredPreQualYears"
                        :label="$t('ADMISSION_DATA.STEP2.YEAR')"
                        :rules="requiredRules"
                        item-text="name"
                        item-value="hrId"
                        outlined
                    >
                      <template v-slot:selection="data">
                        <v-chip v-bind="data.attrs">
                          {{ serverTranslate(data.item.name) }}
                        </v-chip>
                      </template>

                      <template v-slot:item="data">
                        <v-list-item-content>
                          <v-list-item-title
                              v-html="serverTranslate(data.item.name)"
                          />
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>

                  </v-col>

                  <v-col cols="4">
                    <v-text-field
                    v-if="showSeatNo"
                    v-model="data.seatNo"
                    :label="$t('ADMISSION_DATA.STEP2.SEATNO')"
                    :rules="seatNoRules"
                    outlined
                    dense
                    type="text"
                    inputmode="numeric"
                  />
                  </v-col>


                </v-row>
                <v-row>
                   <v-col
                      cols="4"
                      v-if="
                        showSeatNo &&
                        [16,77].includes(data.certificateType) &&
                        data.preQualYear &&
                        data.seatNo
                      "
                    >
                      <v-btn
                        color="primary"
                        @click="fetchStatusLabel"
                      >
                        {{ $t('ADMISSION_DATA.STEP2.PULL_SECONDARY_DATA') }}
                      </v-btn>
                    </v-col>
                   <v-col
                      v-if="data.preQualYear && data.certificateType && [16,77].includes(data.certificateType)
                       &&
                       (
                          (showSeatNo && data.seatNo) ||
                          (!showSeatNo && data.cardID)
                        )
                       "
                      cols="4" lg="4">
                     <span :class="`${statusColor}--text font-weight-bold`">
                      {{ statusLabel }}
                    </span>
                  </v-col>
                </v-row>


                <!-- end prequal data-->

              </v-card-text>
              <v-divider class=""></v-divider>
              <v-card-actions>
                <v-btn
                v-if="
                  ![16,77].includes(data.certificateType) ||
                  (
                    [16,77].includes(data.certificateType) &&
                    (
                      (!showSeatNo &&
                        data.preQualYear &&
                        data.cardID &&
                        pullStatus === 1) ||
                      (showSeatNo &&
                        data.preQualYear &&
                        data.seatNo &&
                        pullStatus === 1)
                    )
                  )
                "
                :disabled="isDobInvalid"
                color="primary"
                @click="submit"
              >
                {{ $t("REGISTER") }}
              </v-btn>



<!--                <v-btn-->
<!--                    v-if="![16,77].includes(data.certificateType)-->
<!--                    ||( [16,77].includes(data.certificateType)-->
<!--                     && data.preQualYear-->
<!--                     && data.cardID-->
<!--                     && this.pullStatus===1)"-->
<!--                    :disabled="isDobInvalid"-->
<!--                    color="primary" @click="submit"-->
<!--                >{{ this.$t("REGISTER") }}-->
<!--                </v-btn>-->

                <v-spacer></v-spacer>
                <v-btn color="blue" text @click="cancel"
                >{{ this.$t("LOGIN_INSTEAD") }}
                </v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <ad-changeLanguage
                    :primaryColor="true"
                    showTooltip="false"
                    v-on:swichLanguage="onLanguageChanged"
                />
              </v-card-actions>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
      <ad-confirmDialog ref="confirm"></ad-confirmDialog>
      <ad-confirmDialog ref="oldAccount"></ad-confirmDialog>
    </v-container>

  </v-content>
</template>

<script>
import serverTranslationsMixin from "@/mixins/serverTranslations.js";
import generalFunctions from "@/mixins/generalFunctions";
import ConfirmDialog from "@/components/shared/ConfirmDialog";
import ChangeLanguage from "@/components/layout/ChangeLanguage";
import Swal from "sweetalert2";

export default {
  props: ['status'],
  components: {
    "ad-changeLanguage": ChangeLanguage,
    "ad-confirmDialog": ConfirmDialog
  },
  mixins: [serverTranslationsMixin, generalFunctions],
  computed: {
     seatNoRules() {
    return [
      v => {
        if (!this.showSeatNo) return true;
        return !!v || this.$t("REQUIRED_FIELD");
      },
      v => {
        if (!this.showSeatNo || !v) return true;
        return this.$store.state.rules.numberField(v);
      }
    ];
  },
    showSeatNo() {
    return (
      this.data.nationality != 1 &&
      [16, 77].includes(Number(this.data.certificateType))
    );
  },
    filteredPreQualYears() {
    if (!Array.isArray(this.data.years)) return [];

    // مفيش rule → كل السنوات
    if (!this.data.PreQualYearRules) {
      return this.data.years;
    }

    const allowedHrIds = this.data.PreQualYearRules
      .split(',')
      .map(v => v.trim())
      .filter(Boolean);

    // السنوات المسموحة
    return this.data.years.filter(
      y => allowedHrIds.includes(y.hrId)
    );
  },
    isDobInvalid() {
      const dobValue = this.data.dOB;
      const rule = v => {
        if (!this.isNotEmpty(v))
          return this.$t("REQUIRED_FIELD");
        if (new Date(v) < this.minDate || new Date(v) > this.maxDate)
          return this.$t("FUTURE_DATE_RANGE");
        return true;
      };
      return rule(dobValue) !== true;
    },

    requiredRules() {
      return this.$store.state.rules.requiredRule;
    },
    direction: function () {
      return this.$store.state.direction;
    },
    universityTitle() {
      return (
          this.$t("CREAT_ACOUNT_IN") + this.serverTranslate(this.$store.getters.getUniversityTitle)
      );
    },
    universityLogo() {
      return this.$store.getters.getUniversityLogo;
    },
    maxDate() {
      var date = new Date();
      date.setFullYear(date.getFullYear() - 14);
      return date;
    },
    minDate() {
      var date = new Date();
      date.setFullYear(date.getFullYear() - 31);
      return date;
    }
  },
  data() {
    return {
      initialLoad: true,
      statusLabel: '',
      statusColor: '',
      pullStatus: 0,
      menu: false,
      radios: 1,
      nationalities: [],
      data: {
        years: [],
        certificateType: "",
        studentSecondaryData: '',
        certificateTypes: [],
        preQualYear: '',
        PreQualYearRules: '',
        arName: "",
        enName: "",
        email: "",
        password: "",
        confirmPassword: "",
        username: "",
        cardID: "",
        seatNo: "",
        cardType: 1,
        dOB: "",
        gender: 13,
        religion : 84,
        nationality: ""
      },
      allowDisabled: true,
      arNameRules: [
        this.$store.state.rules.required,
        this.$store.state.rules.arField,
        v =>
            (v != undefined && v.trim().length > 9) || this.$t("MIN_FIELD") + "10"
      ],
      enNameRules: [
        this.$store.state.rules.required,
        this.$store.state.rules.enField,
        v =>
            (v != undefined && v.trim().length > 9) || this.$t("MIN_FIELD") + "10"
      ],
      usernameRules: [
        this.$store.state.rules.required,
        v => /^[a-zA-Z0-9]{3,10}$/.test(v) || this.$t("USERNAME_VALIDATION")
      ],
      passwordRulse: this.$store.state.rules.passwordRulse,
      confirmPasswordRulse: [
        this.$store.state.rules.required,
        v => v == this.data.password || this.$t("CONFIRM_PASSWORD_VALIDATION")
      ],
      nationalityRules: [
        this.$store.state.rules.required,
      ],
      dOBRules: [
        v => {
          if (!this.isNotEmpty(v))
            return this.$t("REQUIRED_FIELD");
          if (new Date(v) < this.minDate || new Date(v) > this.maxDate)
            return this.$t("FUTURE_DATE_RANGE");
          return true;
        }
      ],
      NIDRulse: this.$store.state.rules.NIDRulse,
      passportRulse: this.$store.state.rules.passportRulse,
      emailRules: this.$store.state.rules.emailRules,
      showPassword: false,
      showConfirmPassword: false
    };
  },
  watch: {
    radios() {
      if (!this.initialLoad) {
        this.data.cardID = '';
      }
    },
    'data.certificateType'() {
      if (!this.initialLoad) this.checkAndFetchStatus();
    },
    'data.preQualYear'() {
      if (!this.initialLoad) this.checkAndFetchStatus();
    },
    'data.cardID'() {
      if (!this.initialLoad) this.checkAndFetchStatus();
    },
    // 'data.seatNo'() {
    //   if (!this.initialLoad) this.checkAndFetchStatus();
    // }
  },
  mounted() {
    this.initData().finally(() => {
      this.initialLoad = false;
    });
    const savedCertificate = localStorage.getItem('certificateTypes');
    const savedYear = localStorage.getItem('years');
    if (savedCertificate) this.data.certificateTypes = savedCertificate;
    if (savedYear) this.data.years = savedYear;

  },
  methods: {
    async initData() {
      const hasEgypt = 1
      const data = {"hasEgypt": hasEgypt}
      return Promise.all([
        await this.$http.post("/api/regions_data/get_countries/", data)
            .then(
                res => {
                  if (res) {
                    this.nationalities = res.data.data
                  }
                }
                , err => {
                  this.$toasted.show(
                      this.serverTranslate(err.response.data.message),
                      {
                        type: "error",
                        icon: "error_outline",
                        theme: "bubble",
                        position: "bottom-left",
                        duration: 3000
                      }
                  );
                }
            ),
        await this.$http.get("/api/users/register_data/")
            .then(res => {
                  if (res && res.data) {
                    this.data.years = res.data.years
                    this.data.certificateTypes = res.data.certificateTypes
                    this.data.PreQualYearRules = res.data.PreQualYearRules
                  }
                }
                , err => {
                  this.$toasted.show(
                      this.serverTranslate(err.response.data.message),
                      {
                        type: "error",
                        icon: "error_outline",
                        theme: "bubble",
                        position: "bottom-left",
                        duration: 3000
                      }
                  );
                }
            )

      ])

      ////////////

    },
    shouldFetchStatus() {
      this.statusLabel = ''
      return (
          [16, 77].includes(this.data.certificateType)
          && this.data.preQualYear
          && !this.isDobInvalid
           &&(!this.showSeatNo && this.data.cardID &&
                this.data.cardID.length === 14 && this.data.cardType === 1)
      );
    },
    fetchStatusLabel() {
      this.statusLabel = "جارى سحب البيانات"
      this.statusColor = 'grey'
      // Call your API here

      this.$http.post("/api/users/pull_secondary_data/", {
        params: {
          cardID:this.showSeatNo ? null : this.data.cardID,
          seatNo: this.showSeatNo ? this.data.seatNo : null,
          preQualYear: this.data.preQualYear,
          certificateType: this.data.certificateType
        }
      }).then(res => {
            if (parseInt(res.data.code) === 200) {
              this.data.studentSecondaryData = res.data.studentSecondaryData
              this.statusLabel = res.data.status_label || 'غير معروف';
              this.statusColor = res.data.status_color || 'grey';
              this.pullStatus = 1

            } else if (parseInt(res.data.code) === 404) {
              this.statusLabel = this.serverTranslate(res.data.msg) || 'غير معروف';
              this.statusColor = 'red';
              this.pullStatus = 0
            } else {
              this.statusLabel = 'الطالب غير موجود على قاعدة البيانات';
              this.statusColor = 'red';
              this.pullStatus = 0
            }
          }
          , err => {
            this.$toasted.show(
                this.serverTranslate(err.res.data.message),
                {
                  type: "error",
                  icon: "error_outline",
                  theme: "bubble",
                  position: "bottom-left",
                  duration: 3000
                }
            );
            this.statusLabel = 'الطالب غير موجود على قاعدة البيانات';
            this.statusColor = 'red';
            this.pullStatus = 0
          });
    },
    checkAndFetchStatus() {
      this.pullStatus = 0;
       this.statusLabel = '';
      if (this.initialLoad) return;
      if (this.shouldFetchStatus()) {
        this.fetchStatusLabel();
      }
    },
    onLanguageChanged: function (direction) {
      if (this.$refs.form) {
        if (this.$el) {
          if (this.$el.querySelector(".error--text")) {
            this.$refs.form.validate();
          }
        }
      }
      this.direction = direction;
    },
    changeNationality() {
      this.data.cardID = ''
      this.data.cardType = this.data.nationality === 1 ? 1 : 2
      this.radios = this.data.nationality === 1 ? 1 : 2
      this.data.gender = 13
      this.data.dOB = ""
    },
    setGenderDob() {
      if (this.data.cardID.length == 14) {
        this.data.dOB = this.extractBirthDate(this.data.cardType, this.data.cardID)
        this.data.gender = this.extractGender(this.data.cardType, this.data.cardID)
        this.$refs.dOB.validate()
      }
    },
    isNotEmpty(str) {
      return !(!str || 0 === str.length || /^\s*$/.test(str));
    },
    submit() {
      if (this.$refs.registerForm.validate()) {
        this.data.cardType = this.radios;
        this.$http.post("/api/users/register/", this.data).then(
            res => {
              if (res.data.flagRegisterConfirm) {
                this.$refs.oldAccount
                    .open("CONFIRMATION_MESSAGE", null, {
                      width: "410px"
                    }, this.serverTranslate(res.data.message))
                    .then(confirm => {
                      if (confirm) {
                        this.data["flagRegisterDelete"] = 1
                        this.$http.post("/api/users/register/", this.data).then(
                            res => {
                              this.$toasted.show(this.serverTranslate(res.data.message), {
                                type: "success",
                                icon: "check_circle_outline",
                                theme: "bubble",
                                position: "bottom-left",
                                duration: 10000
                              });
                              this.$router.push("/login");
                            },
                            err => {
                              this.$toasted.show(
                                  this.serverTranslate(err.response.data.message),
                                  {
                                    type: "error",
                                    icon: "error_outline",
                                    theme: "bubble",
                                    position: "bottom-left",
                                    duration: 5000
                                  }
                              );
                            }
                        )
                      }
                    });
              } else {
                Swal.fire({
                  title: 'تم تسجيل حساب جديد بنجاح',
                  text: 'يمكنك الآن تسجيل الدخول باستخدام اسم المستخدم و كلمة المرور ',
                  icon: 'success',
                  confirmButtonText: 'موافق',
                  showCancelButton: false
                }).then(() => {
                  this.dialog = false;
                  this.reset(true);
                })
                this.$router.push("/login");
              }
            },
            err => {
              this.$toasted.show(
                  this.serverTranslate(err.response.data.message),
                  {
                    type: "error",
                    icon: "error_outline",
                    theme: "bubble",
                    position: "bottom-left",
                    duration: 5000
                  }
              );
            }
        );
      }
    },
    cancel() {
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "GO_TO_LOGIN_CONFIRMATION", {
            width: "410px"
          })
          .then(confirm => {
            if (confirm) {
              this.$router.push("/login");
            }
          });
    },
    passwordChanged() {
      if (!this.data.password) {
        this.allowDisabled = true;
        this.$refs.confirmPassword.reset();
      } else {
        this.allowDisabled = false;
        this.$refs.confirmPassword.validate();
      }

    },
    reset() {
      this.data.gender = 13
      this.data.religion = 84
      this.data.dOB = ""
    }
  }
};
</script>
